import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { APIRequest } from 'api-provider';
import { getEquipments } from './_shared/resources';
import { EquipmentsContent } from './components/EquipmentsContent';
import gtmEvents from 'utils/gtmEvents';

export const Equipments = () => {
  const { token } = useSelector(state => state.api);
  const { merchantId } = useSelector((state) => state.login.user);

  useEffect(() => {
    gtmEvents.merchantPageView();
  }, []);

  return (
    <APIRequest
      resource={getEquipments(token, merchantId)}
      fetch
    >
      {request => {
        const reload = () => request.fetch();

        return (
          <EquipmentsContent
            fetchEquipments={request.fetch}
            isFetching={request.isFetching}
            data={request.response || []}
            error={request.error}
            reload={reload}
          />
        );
      }}
    </APIRequest>
  );
};
